import { ReactNode } from 'react';
import { Span } from './styles';

export type TextComponentProps = {
  fontWeight?: 'regular' | 'bold';
  fontSize?: string;
  color?: string;
  children: string | ReactNode;
}

export function TextComponent({
  fontWeight, fontSize, color, children
}: TextComponentProps) {
  return (
    <Span
      fontSize={fontSize}
      fontWeight={fontWeight}
      color={color}
      children={children}
    />
  );
}
